import service from "./service";

const BANKING_DETAILS_ENDPOINT = "vendors/banking-details";

const getBankingDetails = () => service.get(BANKING_DETAILS_ENDPOINT);
const createBankingDetails = (payload) =>
  service.post(BANKING_DETAILS_ENDPOINT, payload);
const updateBankingDetails = (payload) =>
  service.put(BANKING_DETAILS_ENDPOINT, payload);
const deleteBankingDetails = (vendorId) =>
  service.deleteApi(
    BANKING_DETAILS_ENDPOINT + "/" + encodeURIComponent(vendorId),
  );

const bankingDetailsService = {
  getBankingDetails,
  createBankingDetails,
  updateBankingDetails,
  deleteBankingDetails,
};

export default bankingDetailsService;
